import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";

import {
  ListVideoSubjectSlice,
  successListVideoSubject,
  failureListVideoSubject,
} from "./ListVideosubjectSlice";

import {
  ListVideoTopicSlice,
  successListVideoTopic,
  failureListVideoTopic,
} from "./ListVideoTopicSlice";
import {
  failureListVideoLessonsLists,
  successListVideoLessonsLists,
} from "./ListVideoLessonsList";
import { Note } from "../../../Pages/UserVideoLessonDetail/ILessonsList";
import {
  failureAskAIVideoLessons,
  successAskAIVideoLessons,
  clearAskAIVideoLessonsResponse,
} from "./AskAIVideoLessons";

import {
  failureListNoteVideoLessons,
  successListNoteVideoLessons,
} from "./ListNoteVideoLessons";
import {
  successListGetVideoLessons,
  failureListGetVideoLessons,
} from "./ListGetVideoLessons";
import {
  failureEditNoteVideoLessons,
  successEditNoteVideoLessons,
} from "./EditNoteVideoLessons";
import {
  failureDeleteNoteVideoLessons,
  successDeleteNoteVideoLessons,
} from "./DeleteNoteVideoLessons";
import {
  failureAddNoteVideoLessons,
  successAddNoteVideoLessons,
} from "./AddNoteVideoLessons";
import {
  failureListDiscussionVideoLessons,
  successListDiscussionVideoLessons,
} from "./ListDiscussionVideoLessons";
import {
  failureAddDiscussionVideoLessons,
  successAddDiscussionVideoLessons,
} from "./AddDiscussionVideoLessons";
import {
  failureEditDiscussionVideoLessons,
  successEditDiscussionVideoLessons,
} from "./EditDiscussionVideoLessons";
import {
  failureDeleteDiscussionVideoLessons,
  successDeleteDiscussionVideoLessons,
} from "./DeleteDiscussionVideoLessons";
import {
  failureLikeDiscussionVideoLessons,
  successLikeDiscussionVideoLessons,
} from "./LikeDiscussionVideoLessons";
import {
  failureFavAndWatchLaterVideoLessons,
  successFavAndWatchLaterVideoLessons,
} from "./FavAndWatchLaterVideoLessons";
import {
  failureCourseDetailsVideoLessons,
  successCourseDetailsVideoLessons,
} from "./CourseDetailsVideoLessons";
import {
  failureProgressUpdateVideoLessons,
  successProgressUpdateVideoLessons,
} from "./ProgressUpdateVideoLessons";
import {
  failureVideoLessonAnalytics,
  successVideoLessonAnalytics,
} from "./VideoLessonAnalytics";
// --------------------- List ---------------------
const ListUserVideoLessonApi = () => {
  return api.get("/api/video/subjects");
};

export function* ListUserVideoLessonCall() {
  try {
    const response: AxiosResponse = yield call(ListUserVideoLessonApi);
    yield put(successListVideoSubject(response.data));
  } catch (error) {
    yield put(failureListVideoSubject(error));
  }
}

const ListUserVideoLessonSubjectApi = (action: any) => {
  return api.get("/api/video/topics", { params: action.payload });
};

export function* ListUserVideoLessonSubjectfromTopicCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      ListUserVideoLessonSubjectApi,
      action
    );
    yield put(successListVideoTopic(response.data));
  } catch (error) {
    yield put(failureListVideoTopic(error));
  }
}

const ListUserVideoLessonListsApi = (action: any) => {
  console.log("🚀 API Call Params:", action.payload);
  return api.get("/api/video/list", { params: action.payload });
};

export function* ListUserVideoLessonListsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      ListUserVideoLessonListsApi,
      action
    );
    yield put(successListVideoLessonsLists(response.data));
  } catch (error) {
    yield put(failureListVideoLessonsLists(error));
  }
}

const ListNoteVideoLessonsApi = (action: any) => {
  console.log("called GetNote");
  return api.get("/api/video/get-note", { params: action.payload });
};

export function* ListNoteVideoLessonsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(ListNoteVideoLessonsApi, action);
    yield put(successListNoteVideoLessons(response.data));
  } catch (error) {
    yield put(failureListNoteVideoLessons(error));
  }
}
// add note
const AddNoteVideoLessonsApi = (action: PayloadAction<Note>) => {
  return api.post("/api/video/add-note", action.payload);
};

export function* AddNoteVideoLessonsCall(action: PayloadAction<Note>) {
  try {
    const response: AxiosResponse = yield call(AddNoteVideoLessonsApi, action);
    yield put(successAddNoteVideoLessons(response.data));
  } catch (error) {
    yield put(failureAddNoteVideoLessons(error));
  }
}

// edit note
const EditNoteVideoLessonsApi = (action: PayloadAction<Note>) => {
  return api.put("/api/video/edit-note", action.payload);
};

export function* EditNoteVideoLessonsCall(action: PayloadAction<Note>) {
  try {
    const response: AxiosResponse = yield call(EditNoteVideoLessonsApi, action);
    yield put(successEditNoteVideoLessons(response.data));
  } catch (error) {
    yield put(failureEditNoteVideoLessons(error));
  }
}

// delete note
const DeleteNoteVideoLessonsApi = (action: any) => {
  return api.delete("/api/video/delete-note", { params: action.payload });
};

export function* DeleteNoteVideoLessonsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      DeleteNoteVideoLessonsApi,
      action
    );
    yield put(successDeleteNoteVideoLessons(response.data));
  } catch (error) {
    yield put(failureDeleteNoteVideoLessons(error));
  }
}

const ListGetVideoLessonsApi = (action: any) => {
  console.log("🚀 API Call Params:", action.payload);
  return api.get("/api/video/get", { params: action.payload });
};

export function* ListGetVideoLessonsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(ListGetVideoLessonsApi, action);
    yield put(successListGetVideoLessons(response.data));
  } catch (error) {
    yield put(failureListGetVideoLessons(error));
  }
}

const AskAIVideoLessonsApi = (action: PayloadAction<any>) => {
  return api.post("/api/video/ai", action.payload);
};

export function* AskAIVideoLessonsCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(AskAIVideoLessonsApi, action);
    yield put(successAskAIVideoLessons(response.data));
  } catch (error) {
    yield put(failureAskAIVideoLessons(error));
  }
}

const ListDiscussionVideoLessonsApi = (action: any) => {
  console.log("🚀 API Call Params:", action.payload);
  return api.get("/api/video/discussion/get", { params: action.payload });
};

export function* ListDiscussionVideoLessonsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      ListDiscussionVideoLessonsApi,
      action
    );
    yield put(successListDiscussionVideoLessons(response.data));
  } catch (error) {
    yield put(failureListDiscussionVideoLessons(error));
  }
}

const AddDiscussionVideoLessonsApi = (action: any) => {
  return api.post("/api/video/discussion/add", action.payload);
};

export function* AddDiscussionVideoLessonsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      AddDiscussionVideoLessonsApi,
      action
    );
    console.log("🚀 New Discussion Response:", response);
    yield put(successAddDiscussionVideoLessons(response.data));
    return response.data;
  } catch (error) {
    yield put(failureAddDiscussionVideoLessons(error));
  }
}

const EditDiscussionVideoLessonsApi = (action: any) => {
  return api.put("/api/video/discussion/edit", action.payload);
};

export function* EditDiscussionVideoLessonsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      EditDiscussionVideoLessonsApi,
      action
    );
    yield put(successEditDiscussionVideoLessons(response.data));
  } catch (error) {
    yield put(failureEditDiscussionVideoLessons(error));
  }
}

const DeleteDiscussionVideoLessonsApi = (action: any) => {
  return api.delete("/api/video/discussion/delete", {
    params: action.payload,
  });
};

export function* DeleteDiscussionVideoLessonsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      DeleteDiscussionVideoLessonsApi,
      action
    );
    yield put(successDeleteDiscussionVideoLessons(response.data));
  } catch (error) {
    yield put(failureDeleteDiscussionVideoLessons(error));
  }
}

const LikeDiscussionVideoLessonsApi = (action: any) => {
  return api.post("/api/video/like-comment", action.payload);
};

export function* LikeDiscussionVideoLessonsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      LikeDiscussionVideoLessonsApi,
      action
    );
    yield put(successLikeDiscussionVideoLessons(response.data));
    return response.data;
  } catch (error) {
    yield put(failureLikeDiscussionVideoLessons(error));
  }
}

const FavAndWatchLaterVideoLessonsApi = (action: any) => {
  return api.post("/api/video/favorites", action.payload);
};

export function* FavAndWatchLaterVideoLessonsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      FavAndWatchLaterVideoLessonsApi,
      action
    );
    yield put(successFavAndWatchLaterVideoLessons(response.data));
    return response.data;
  } catch (error) {
    yield put(failureFavAndWatchLaterVideoLessons(error));
  }
}
const CourseDetailsVideoLessonsApi = (action: any) => {
  return api.get("/api/video/course-details", { params: action.payload });
};

export function* CourseDetailsVideoLessonsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      CourseDetailsVideoLessonsApi,
      action
    );
    yield put(successCourseDetailsVideoLessons(response.data));
    return response.data;
  } catch (error) {
    yield put(failureCourseDetailsVideoLessons(error));
  }
}

const ProgressUpdateVideoLessonsApi = (action: any) => {
  return api.post("/api/video/progress", action.payload);
};

export function* ProgressUpdateVideoLessonsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      ProgressUpdateVideoLessonsApi,
      action
    );
    yield put(successProgressUpdateVideoLessons(response.data));
    return response.data;
  } catch (error) {
    yield put(failureProgressUpdateVideoLessons(error));
  }
}

// --------------------- List ---------------------
const ListVideoLessonAnalyticsApi = (action: any) => {
  return api.get("/api/video/analytics", { params: action.payload });
};

export function* ListVideoLessonAnalyticsCall(action: any) {
  try {
    const response: AxiosResponse = yield call(
      ListVideoLessonAnalyticsApi,
      action
    );
    yield put(successVideoLessonAnalytics(response.data));
  } catch (error) {
    yield put(failureVideoLessonAnalytics(error));
  }
}
